<template>
  <section v-if="screenContent" class="scene">
    <!-- people -->
    <VillageNpc1 v-if="screenContent.NPC1" :npcs="screenContent.NPC1" />
    <VillageNpc2 v-if="screenContent.NPC2" :npcs="screenContent.NPC2" />
    <VillageNpc3 v-if="screenContent.NPC3" :npcs="screenContent.NPC3" />
    <!-- arrows -->
    <Arrow
      :text="screenContent.ButtonLeft"
      direction="left"
      class="d-none d-flex-md"
      @click="clickFriends"
    />
    <Arrow
      :text="screenContent.ButtonDown"
      direction="down"
      @click="clickUnderground"
    />
    <Arrow
      :text="screenContent.ButtonRight"
      direction="right"
      class="d-none d-flex-md"
      @click="clickWorld"
    />
    <!-- content -->
    <div class="content content--top">
      <div class="container">
        <picture v-if="screenContent.Heading">
          <img
            class="heading"
            alt="Heading"
            :src="screenContent.Heading"
            :srcset="`${screenContent.Heading} 1400w`"
            width="1213"
            height="335"
            sizes="100vw"
          >
        </picture>
        <div class="mobilelinks d-block d-none-md">
          <button class="btn btn--pink btn--half btn--block mb-1" @click="clickFriends">
            {{ screenContent.ButtonLeft }}
          </button>
          <button class="btn btn--pink btn--half btn--block mb-1" @click="clickWorld">
            {{ screenContent.ButtonRight }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Arrow from '@/components/parts/Arrow.vue'
import VillageNpc1 from '@/components/npcs/VillageNpc1.vue'
import VillageNpc2 from '@/components/npcs/VillageNpc2.vue'
import VillageNpc3 from '@/components/npcs/VillageNpc3.vue'

export default {
  name: 'Village',

  components: {
    Arrow,
    VillageNpc1,
    VillageNpc2,
    VillageNpc3
  },

  computed: {
    screenContent () {
      return this.$store.getters.getContentVillage
    },
    sceneName () {
      return this.$store.getters.getSceneName
    }
  },

  mounted () {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '1'
    })
  },

  methods: {
    clickFriends () {
      this.$gtm.trackEvent({
        'event': 'Find Friends Click'
      })
      this.$store.dispatch('setScene', 'friends')
    },
    clickUnderground () {
      this.$gtm.trackEvent({
        'event': 'Choose Your Hero Click'
      })
      this.$store.dispatch('setScene', 'underground')
    },
    clickWorld () {
      this.$gtm.trackEvent({
        'event': 'Explore World Click'
      })
      this.$store.dispatch('setScene', 'world')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

.mobilelinks {
  width: 250px;
  margin: 20px auto;
}
.heading {
  display: none;

  @include breakpointHeight(md) {
    display: block;
  }
  @include breakpoint(lg) {
    max-width: 800px;

    @include breakpointHeight(xl) {
      max-width: 100%;
    }
  }
}
</style>
